import 'reflect-metadata'
import { Inject } from 'inversify-props'
import { LojaServiceAdapter } from './adapter'

export class DeleteLojaUseCase {
	@Inject('LojaServiceAdapter')
	private service!: LojaServiceAdapter

	delete = async (id: string): Promise<void> => await this.service.remove(id)
}
